// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_EmitInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for invoice emission
 *
 * Validates invoice emission requests with customer, amounts, and items.
 */
import { registerContract } from './validate'

export interface Invoice_EmitInput {
franchise_id: number
invoice_type: string
customer_doc: string
customer_doc_type: string
customer_name: string
total_amount: number
tax_amount: number
taxless_amount: number
emission_date: string
customer_email?: string
related_entity_type?: string
related_entity_id?: number
items?: unknown[]
}

registerContract('Invoice_EmitInput', {
  franchise_id:        { type: 'number',  required: true },
  invoice_type:        { type: 'string',  required: true },
  customer_doc:        { type: 'string',  required: true },
  customer_doc_type:   { type: 'string',  required: true },
  customer_name:       { type: 'string',  required: true },
  total_amount:        { type: 'number',  required: true },
  tax_amount:          { type: 'number',  required: true },
  taxless_amount:      { type: 'number',  required: true },
  emission_date:       { type: 'string',  required: true },
  customer_email:      { type: 'string',  required: false },
  related_entity_type: { type: 'string',  required: false },
  related_entity_id:   { type: 'number',  required: false },
  items:               { type: 'array',   required: false },
})
